// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"4d67af05","289":"3e632232","362":"82f14c04","453":"44fd104a","461":"79dd0485","783":"b2659a8a","806":"36ac2155","997":"77d3103f"}[chunkId] + ".chunk.js";
};